import React from 'react';
import AccordionWrapper from '@/components/accordion/AccordionWrapper';
import SimpleAccordion from '@/components/accordion/SimpleAccordion';
import UsersGroupsTable from '../groups/containers/UsersGroupsTable';

const UserPanelAccordion = ({
  category,
  code,
  panels,
  updatePanels,
}) => (
  <AccordionWrapper fluid open={panels?.includes(0)} className="aridhia-user-panel-accordion mt-20">
    <SimpleAccordion
      active={panels?.includes(0)}
      headerId="user.breadcrumb.groups_title"
      index={0}
      onClick={() => updatePanels(category, code, 0)}
    >
      <UsersGroupsTable code={code} category={category} />
    </SimpleAccordion>
  </AccordionWrapper>
);

export default UserPanelAccordion;
